// ─────────────────────────────────────────────────────────────────────────────
// ListView — the List View of the Nodes page: a toolbar over a sortable table.
//   The sibling of ./NodeMap; NetworkCard swaps between the two.
//
//   It also hosts the row actions. Each of the three modals in ./rowActions is
//   opened by storing the node it targets — null means closed — because they are
//   triggered from a table row and concern nothing above this component.
//   "View Details" is not here: it is the same NodeDetailModal a row click
//   opens, which the page already owns, so it reuses onSelect.
//
//   Edit and Delete WRITE, so they report back through `onChanged` (the page's
//   refetch). The modals stay open on success to show what the server did — an IP
//   change closes sessions, a delete states what it destroyed — so the refresh
//   happens while the report is still on screen rather than after it closes.
//
//   `canWrite` decides whether the write controls exist at all. It mirrors the
//   backend's read_write gate on node_monitoring (Admin + Security Admin); a
//   read-only viewer gets the table and View Details, and no Add/Edit/Delete.
//
//   Search/filter/sort state lives in useNodeFilters and arrives as `filters`.
// ─────────────────────────────────────────────────────────────────────────────
import { useState } from "react";
import ListToolbar from "./ListToolbar";
import NodesTable from "./NodesTable";
import DownloadPackageModal from "./rowActions/DownloadPackageModal";
import EditNodeModal from "./rowActions/EditNodeModal";
import DeleteNodeModal from "./rowActions/DeleteNodeModal";

export default function ListView({
  filters, loading, selectedId, onSelect, onAddNode, onChanged, canWrite = false,
}) {
  // Each holds the node whose modal is open, or null.
  const [packageNode, setPackageNode] = useState(null);
  const [editNode, setEditNode]       = useState(null);
  const [deleteNode, setDeleteNode]   = useState(null);

  return (
    <>
      <ListToolbar
        search={filters.search}
        onSearch={filters.setSearch}
        filterStatus={filters.filterStatus}
        onFilter={filters.setFilterStatus}
        onAddNode={onAddNode}
        canWrite={canWrite}
      />
      <NodesTable
        rows={filters.rows}
        loading={loading}
        isFiltered={filters.isFiltered}
        sortCol={filters.sortCol}
        sortDir={filters.sortDir}
        onSort={filters.toggleSort}
        selectedId={selectedId}
        onSelect={onSelect}
        onDownload={setPackageNode}
        onEdit={setEditNode}
        onDelete={setDeleteNode}
        canWrite={canWrite}
      />

      {packageNode && (
        <DownloadPackageModal node={packageNode} onClose={() => setPackageNode(null)} />
      )}
      {editNode && (
        <EditNodeModal
          node={editNode}
          onClose={() => setEditNode(null)}
          onSaved={onChanged}
        />
      )}
      {deleteNode && (
        <DeleteNodeModal
          node={deleteNode}
          onClose={() => setDeleteNode(null)}
          onDeleted={onChanged}
        />
      )}
    </>
  );
}
